import { Reducer } from "redux";
import IDataGridState from "./IDataGridState";
import { DataGridAction, DataGridActionTypes } from "./DataGridActions";
import { getPaginationDefaults } from "features/shared/helpers/queryParams";

const initialState: IDataGridState = {
  gridSettings: {},
};

const DataGridReducer: Reducer<IDataGridState, DataGridAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case DataGridActionTypes.SET_GRID_FILTR_URLPARAMS_SAGA: {
      let newGridSettings = state.gridSettings;
      newGridSettings[action.data.key] = {
        ...newGridSettings[action.data.key],
        filtrUrlSearchParams: action.data.value,
      };

      return {
        ...state,
        gridSettings: {
          ...newGridSettings,
        },
      };
    }
    case DataGridActionTypes.RESET_GRID_FILTR_URLPARAMS_SAGA: {
      let newGridSettings = state.gridSettings;
      newGridSettings[action.data] = {
        ...newGridSettings[action.data],
        filtrUrlSearchParams: undefined,
      };

      return {
        ...state,
        gridSettings: {
          ...newGridSettings,
        },
      };
    }
    case DataGridActionTypes.SET_GRID_PAGINATION_URLPARAMS_SAGA: {
      let newGridSettings = state.gridSettings;
      newGridSettings[action.data.key] = {
        ...newGridSettings[action.data.key],
        paginationUrlSearchParams: action.data.value,
      };

      return {
        ...state,
        gridSettings: {
          ...newGridSettings,
        },
      };
    }
    case DataGridActionTypes.RESET_GRID_PAGINATION_URLPARAMS_SAGA: {
      let defaultPaginationParams = getPaginationDefaults();

      let newGridSettings = state.gridSettings;
      newGridSettings[action.data] = {
        ...newGridSettings[action.data],
        paginationUrlSearchParams: defaultPaginationParams.toString(),
      };

      return {
        ...state,
        gridSettings: {
          ...newGridSettings,
        },
      };
    }
    case DataGridActionTypes.SET_GRID_PAGINATION_PAGE_SIZE_SAGA: {
      let newGridSettings = state.gridSettings;
      newGridSettings[action.data.key] = {
        ...newGridSettings[action.data.key],
        defaultPageSize: action.data.value,
      };

      return {
        ...state,
        gridSettings: {
          ...newGridSettings,
        },
      };
    }
    case DataGridActionTypes.SET_GRID_SORTING_URLPARAMS_SAGA: {
      let newGridSettings = state.gridSettings;
      newGridSettings[action.data.key] = {
        ...newGridSettings[action.data.key],
        sortingUrlSearchParams: action.data.value,
      };

      return {
        ...state,
        gridSettings: {
          ...newGridSettings,
        },
      };
    }
    case DataGridActionTypes.COMPUTE_GRID_URLPARAMS: {
      let newGridSettings = state.gridSettings;
      newGridSettings[action.data.key] = {
        ...newGridSettings[action.data.key],
        computedUrlSearchParams: action.data.value,
      };

      return {
        ...state,
        gridSettings: {
          ...newGridSettings,
        },
      };
    }
    case DataGridActionTypes.RESET_ALL_GRIDS: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};

export default DataGridReducer;
